export default __webpack_public_path__ + "static/media/246.33444c4e.jpg";